import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Button, Spinner, Alert, InputGroup, Form } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Base_URL } from "../url";

export default function AllProductionOrders() {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");

  const FETCH_ENDPOINT = `${Base_URL}/ProductionExecution`;

  useEffect(() => {
    loadOrders();
    // eslint-disable-next-line
  }, []);

  const loadOrders = async () => {
    setError("");
    setLoading(true);
    try {
      const res = await axios.get(FETCH_ENDPOINT);
      const arr = Array.isArray(res?.data) ? res.data : [];
      setOrders(arr);
    } catch (err) {
      console.error("Failed fetching production orders:", err);
      setError(err.response?.data?.message ?? err.message ?? "Failed to load production orders");
    } finally {
      setLoading(false);
    }
  };

  const handleExecuteClick = (productionOrderId) => {
    if (!productionOrderId) return;
    // navigate to the route you specified
    navigate(`/executeProduction-order/${productionOrderId}`);
  };

  // small formatter helpers
  const fmtDate = (iso) => {
    if (!iso) return "-";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso.split("T")[0] ?? iso;
    return d.toISOString().slice(0, 10);
  };

  const fmtTime = (t) => {
    if (!t) return "-";
    // t might be "HH:MM:SS" or "HH:MM"
    return t.length >= 5 ? t.slice(0,5) : t;
  };

  // filter by query (id / plan id / status)
  const filtered = orders.filter(o => {
    if (!query) return true;
    const q = query.toLowerCase();
    return (
      String(o.productionOrderId ?? "").toLowerCase().includes(q) ||
      String(o.productionPlanId ?? "").toLowerCase().includes(q) ||
      String(o.productionOrderStatusId ?? "").toLowerCase().includes(q)
    );
  });

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <Row className="mb-3 align-items-center">
          <Col>
            <h3 className="fields-title">Production Orders</h3>
            <div className="text-muted">Fetched from <code>/ProductionExecution</code></div>
          </Col>

          <Col md="auto">
            <Button variant="outline-secondary" size="sm" onClick={loadOrders} disabled={loading}>
              {loading ? <><Spinner animation="border" size="sm" /> Refresh</> : "Refresh"}
            </Button>
          </Col>
        </Row>

        {error && <Alert variant="danger" onClose={() => setError("")} dismissible>{error}</Alert>}

        <Row className="mb-3">
          <Col md={6}>
            <InputGroup>
              <Form.Control
                placeholder="Search by order id / plan id / status..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <Button variant="outline-primary" onClick={() => setQuery("")}>Clear</Button>
            </InputGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="border rounded p-3">
              {loading && orders.length === 0 ? (
                <div className="text-center py-4"><Spinner animation="border" /></div>
              ) : (
                <Table responsive bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Plan ID</th>
                      <th>Planned Start</th>
                      <th>Duration</th>
                      <th>Status</th>
                      <th>Approx Cost</th>
                      <th>Organisation</th>
                      <th>Created</th>
                      <th style={{ width: 120 }}>Execute</th>
                      <th style={{ width: 120 }}>Goods Issue Report</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filtered.length === 0 ? (
                      <tr>
                        <td colSpan={9} className="text-center text-muted">No production orders found.</td>
                      </tr>
                    ) : filtered.map((o, idx) => (
                      <tr key={`${o.productionOrderId ?? "order"}-${idx}`}>
                        <td>{o.productionOrderId ?? "-"}</td>
                        <td>{o.productionPlanId ?? "-"}</td>
                        <td>
                          {fmtDate(o.plannedStartDate)} {fmtTime(o.plannedStartTime)} {o.plannedStartTimezone ? `(${o.plannedStartTimezone})` : ""}
                        </td>
                        <td>{o.approxDuration ?? "-"} {o.approxDuration ? "H" : ""}</td>
                        <td>{o.productionOrderStatusId ?? "-"}</td>
                        <td>{o.approxCost ? `${o.approxCost} ${o.approxCostCurrency ?? ""}` : "-"}</td>
                        <td>{o.organisationId ?? "-"}</td>
                        <td>{fmtDate(o.createddate)} {fmtTime(o.createdtime)}</td>
                        <td className="text-end">
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => handleExecuteClick(o.productionOrderId)}
                            disabled={!o.productionOrderId}
                          >
                            Execute
                          </Button>
                   
                        </td>
                               <td>
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => navigate(`/goodsIssueReport/${o.productionOrderId}`)}
                            disabled={!o.productionOrderId}
                          >
                            View
                          </Button>
                          </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
